exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 20px;\n  right: 20px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column; }\n  .error .notFoundTitle {\n    /* stylelint-disable-next-line unit-whitelist */\n    font-size: 30vw;\n    color: #06a6d3; }\n  .error .notFoundText {\n    /* stylelint-disable-next-line unit-whitelist */\n    font-size: 4vh;\n    /* stylelint-disable-next-line unit-whitelist */\n    line-height: 4vh;\n    text-align: center; }\n", ""]);

// exports
